import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  sectionRoot: {
    display: 'flex',
    position: 'relative',
    boxSizing: 'border-box',
    marginTop: '16px',
    alignItems: 'center',
    borderBottom: '1px solid #C6C6C6',
    paddingBottom: '8px'
  },

  sectionLabels: {
    fontSize: theme.size.sm,
    paddingRight: 16
  },

  input: {
    border: 'none',
    height: '31px',
    padding: '0',
    outline: 'none',
    background: 'transparent',
    fontSize: theme.size.sm,
    flex: 1,
    color: '#1F1F1F'
  },

  resultsContainer: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    padding: '16px',
    background: 'white',

    '& > ul': {
      padding: '0'
    }
  },

  result: {
    borderRadius: '8px',
    height: '48px',
    padding: '0 12px',
    fontSize: theme.size.base,

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  emailResult: {
    fontSize: theme.size.sm,
    cursor: 'inherit'
  },

  newContact: {
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.base,
    height: '48px',
    cursor: 'pointer',
    padding: '0 12px',

    '&:hover': {
      background: '#F5F6F8'
    },
    '& strong': {
      margin: '0px 4px'
    }
  },

  chip: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    marginRight: '5px',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    padding: '6px 12px',
    background: 'white',
    cursor: 'default',
    fontSize: theme.size.base,
    color: '#1F1F1F',

    '& svg': {
      cursor: 'pointer',
      paddingLeft: 6
    }
  },

  chipsSection: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flex: 1
  },

  extraChannelsLabel: {},

  extraChannelsResults: {
    marginTop: 10
  },

  emailValue: {
    color: 'grey',
    fontSize: theme.size.sm,
    cursor: 'inherit',
    display: 'block'
  },

  noResults: {
    color: 'grey',
    padding: '0 12px',
    borderRadius: '8px',
    cursor: 'default',
    height: '48px',
    display: 'flex',
    alignItems: 'center'
  },

  addLabel: {
    color: 'grey',
    marginRight: 5
  },

  transparentInput: {
    border: '0',
    outline: '0',
    maxWidth: 125
  },

  newContactName: {
    [theme.breakpoints.down('md')]: {
      maxWidth: 65,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }
}))

export default useStyles
